const API_URL = 'https://api.coldstartserver.com/api/build-page-speed';
const API_KEY_SECRET = process.env.REACT_APP_API_KEY_SECRET;

console.log('Environment variables:', {
  API_KEY_SECRET,
  REACT_APP_API_KEY_SECRET: process.env.REACT_APP_API_KEY_SECRET,
  NODE_ENV: process.env.NODE_ENV,
  allEnvVars: Object.keys(process.env)
});

export const fetchPageData = async ({
  category = '',
  country = '',
  state = '',
  city = '',
  language = '',
  pageType = '',
  competitor = ''
}) => {
  try {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        api_key_secret: API_KEY_SECRET,
        category,
        country,
        state,
        city,
        language,
        page_type: pageType,
        competitor
      })
    };
    const response = await fetch(API_URL, options);
    const data = await response.json();

    return data;

  } catch (error) {
    console.error('Error fetching page data:', error);
    throw error;
  }
};